import React from 'react';
import { useSelector } from 'react-redux';
import CommentsModalTemplate from '../../../commentsModalTemplate';
import { useCommentsQuery } from '../../providers/commentsQuery';

const selectUserWorkerId = (state) =>
  Number(state.authentication.userInfo?.WorkerId ?? '');

const Body = () => {
  const { data, isFetching } = useCommentsQuery();

  const workerId = useSelector(selectUserWorkerId);

  const isAuthor = (comment) => {
    return comment.worker.id === workerId;
  };

  return (
    <CommentsModalTemplate.ModalBody
      data={data}
      isLoading={isFetching}
      isAuthor={isAuthor}
    />
  );
};

export default Body;
